import type { CommissionRule } from '../types'

export type CommissionRuleSaleEvalContext = {
  vehicleType: 'new' | 'used'
  paymentFormIds: string[]
  saleSalespersonId: string
  now?: Date
  applyStoreRulesToAllSales?: boolean
}

export type CommissionRuleSaleEvaluation = {
  applicable: boolean
  reasonKeys: string[]
  infoKeys: string[]
}

export function evaluateCommissionRuleForSale(
  rule: CommissionRule,
  ctx: CommissionRuleSaleEvalContext,
): CommissionRuleSaleEvaluation {
  const now = ctx.now ?? new Date()
  const reasonKeys: string[] = []

  if (!rule.isActive) {
    return { applicable: false, reasonKeys: ['inactive'], infoKeys: [] }
  }

  if (rule.vehicleType && rule.vehicleType !== ctx.vehicleType) {
    reasonKeys.push('vehicle_type')
  }

  if (
    rule.paymentFormId &&
    ctx.paymentFormIds.length > 0 &&
    !ctx.paymentFormIds.includes(rule.paymentFormId)
  ) {
    reasonKeys.push('payment_form')
  }

  if (rule.startDate && new Date(rule.startDate) > now) {
    reasonKeys.push('vigence_before_start')
  }
  if (rule.endDate && new Date(rule.endDate) < now) {
    reasonKeys.push('vigence_after_end')
  }

  const at = rule.applicableTo || 'salesperson'
  if (at === 'salesperson') {
    if (
      !rule.sharedAmongAllSalespeople &&
      rule.salespersonId &&
      rule.salespersonId !== ctx.saleSalespersonId
    ) {
      reasonKeys.push('salesperson_scope')
    }
  }

  const applicable = reasonKeys.length === 0
  const infoKeys: string[] = []

  if (applicable && (at === 'dealership' || at === 'manager')) {
    const applyStore = ctx.applyStoreRulesToAllSales !== false
    if (!applyStore) {
      infoKeys.push('manager_dealership_auto_disabled')
    }
  }

  return { applicable, reasonKeys, infoKeys }
}
